import estoque from './estoque';
import cadastros from './cadastros';
// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
    items: [cadastros, estoque]
};
export default menuItems;
